<template>
  <div
    class="file-detail-modal-wrap"
    :style="{ display: visible ? 'block' : 'none' }"
    @click="onClose"
  >
    <div v-if="visible" class="file-detail-modal">
      <div class="file-detail-modal-close" @click="onClose">
        <close-icon class="file-detail-modal-close-icon" />
      </div>
      <img
        class="file-detail-modal-img"
        :src="url"
        :alt="filename"
      />
    </div>
  </div>
</template>

<script>
import CloseIcon from '../icon/close.vue';

export default {
  name: 'FileDetailModal',
  components: {
    CloseIcon,
  },

  data() {
    return {
      url: '',
      filename: '',
      visible: false,
    };
  },

  methods: {
    show(options = {}) {
      this.url = options.url;
      this.filename = options.filename;
      this.visible = true;
    },

    onClose() {
      console.log('==123')
      this.url = '';
      this.filename = '';
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/index.scss";
.file-detail-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.8);

  &-wrap {
    position: relative;
    overflow: hidden;
  }

  &-close {
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
    transition: transform $transition-easeinout-001;

    &-icon {
      width: 40px;
      height: 40px;

      ::v-deep {
        path {
          fill: #ffffff
        }
      }
    }

    &:hover {
      transform: scale(1.2);
    }
  }

  &-img {
    max-width: 80vw;
    max-height: 80vh;
  }
}
</style>
